import { toast } from 'react-toastify'

import { wretchClient } from '~in-app/lib/wretch/wretch'
import { ListingResponse } from '~in-app/types/api.dto'

import { RoleQuery, Roles } from './types'

export const fetchRolesList = async (params?: { abortCtrl?: AbortController | AbortSignal, query?: RoleQuery }) => {
  return wretchClient
    .url('/admin/1.0/roles')
    .signal(params?.abortCtrl)
    .query(params?.query || {})
    .get()
    .json<ListingResponse<Roles>>()
    .catch((err) => {
      const parsedData = JSON.parse(err.message)
      toast.error(`Error: ${parsedData.message}`, { hideProgressBar: false, autoClose: 1500 })
      return null
    })
}

export const fetchRoleDetails = async (id: string) => {
  return wretchClient
    .url(`/admin/1.0/roles/${id}`)
    .get()
    .json<[Roles]>()
    .catch((err) => {
      const parsedData = JSON.parse(err.message)
      toast.error(`Error: ${parsedData.message}`, { hideProgressBar: false, autoClose: 1500 })
      return null
    })
}

export const updateRoleStatus = async (id: string, status: boolean) => {
  return wretchClient
    .url(`/admin/1.0/roles/${id}/${status}`)
    .patch()
    .res()
    .then(() => {
      toast.success(`Status Updated successfully`, { position: 'top-center', hideProgressBar: false, autoClose: 500 })
    })
    .catch((err) => {
      const parsedData = JSON.parse(err.message)
      toast.error(`${parsedData.title}: ${parsedData.message}`, { hideProgressBar: false, autoClose: 1500 })
      return null
    })
}

export const deleteRole = async (id: string) => {
  return wretchClient
    .url(`/admin/1.0/roles/${id}`)
    .delete()
    .res()
    .then(() => {
      toast.success(`Status Deleted successfully`, { position: 'top-center', hideProgressBar: false, autoClose: 500 })
    })
    .catch((err) => {
      const parsedData = JSON.parse(err.message)
      toast.error(`${parsedData.title}: ${parsedData.message}`, { hideProgressBar: false, autoClose: 1500 })
      return null
    })
}
export const addRole = async (values: any) => {
  return wretchClient
    .url('/admin/1.0/roles')
    .post(values)
    .res()
    .then(() => {
      toast.success(`Role Added successfully`, { position: 'top-center', hideProgressBar: false, autoClose: 500 })
    })
    .catch((err) => {
      const parsedData = JSON.parse(err.message)
      toast.error(`${parsedData.title}: ${parsedData.message}`, { hideProgressBar: false, autoClose: 1500 })
      return null
    })
}
export const updateRole = async (values: any) => {
  return wretchClient
    .url('/admin/1.0/roles')
    .put(values)
    .res()
    .then(() => {
      toast.success(`Role Updated successfully`, { position: 'top-center', hideProgressBar: false, autoClose: 500 })
    })
    .catch((err) => {
      const parsedData = JSON.parse(err.message)
      toast.error(`${parsedData.title}: ${parsedData.message}`, { hideProgressBar: false, autoClose: 1500 })
      return null
    })
}

export const updateRolePrivileges = async (roleId: string, privilegeIds: string[]) => {
  return wretchClient
    .url(`/admin/1.0/roles/${roleId}/priviledges`)
    .put(privilegeIds)
    .res()
    .then(() => {
      toast.success(`Privileges for Role ${roleId} updated successfully`, { position: 'top-center', hideProgressBar: false, autoClose: 500 })
    })
    .catch((err) => {
      const parsedData = JSON.parse(err.message)
      toast.error(`${parsedData.title}: ${parsedData.message}`, { hideProgressBar: false, autoClose: 1500 })
      return null
    })
}
